import React, { useEffect, useState } from "react";
import { viewSettlementSchedule } from "../../../Services/GNA/GetData";
import Styles from "./CompanyDetails.module.css";
import Settlement from "../../Modals/Schedule/Settlement/Settlement";
import { useSelector } from "react-redux";

const SchdeuleTable = ({ id, companyId }) => {
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  );
  const [scheduleList, setScheduleList] = useState(null);
  const [settlement, setSettlement] = useState({
    status: false,
    id: "",
    data: "",
  });
  useEffect(() => {
    renderScheuleData();
  }, [id, companyId]);

  const renderScheuleData = async () => {
    let res = await viewSettlementSchedule({
      type: `consumerId=${id}`,
      companyId: companyId,
    });
    if (res?.data) {
      setScheduleList(res.data?.data?.page || []);
    }
  };

  return (
    <>
      {settlement.status && (
        <Settlement
          open={settlement?.status}
          handleClose={() => setSettlement({ status: false, id: "", data: "" })}
          id={settlement?.id}
          data={settlement?.data}
          admin={true}
          renderScheuleData={renderScheuleData}
        />
      )}
      <div>
        <div className="display_flex_row tableHeading">
          <div style={{ width: "10%" }}>Company 2</div>
          <div style={{ width: "10%" }}>Date</div>
          <div style={{ width: "15%" }}>Time</div>
          <div style={{ width: "15%" }}>Delivered Volume (MWh)</div>
          <div style={{ width: "15%" }}>Rate(₹/kWh)</div>
          <div style={{ width: "10%" }}>Status</div>
          <div style={{ width: "10%" }}>Activity</div>
        </div>
        <div className={`scroll_bar_y ${Styles.scheduleMainDetails}`}>
          {scheduleList === null ? (
            <div className="pending">Loading...</div>
          ) : scheduleList.length === 0 ? (
            <div className="pending">No Data Found</div>
          ) : (
            <>
              {scheduleList?.map((ele, index) => (
                <div className="display_flex_row tableDetails">
                  <div style={{ width: "10%" }}>
                    {ele?.counterPartyCompanyName} {ele?.scheduleId}
                  </div>
                  <div style={{ width: "10%" }}>{ele?.fromDate}</div>
                  <div style={{ width: "15%" }}>
                    {ele?.fromBlock?.timeBlock?.split("-")?.[0]} -{" "}
                    {ele?.toBlock?.timeBlock?.split("-")?.[1]}
                  </div>
                  <div style={{ width: "15%" }}>
                    {ele?.deliveredVolume?.toFixed(2)}
                  </div>
                  <div style={{ width: "15%" }}>
                    {ele?.energyRate?.toFixed(2)}
                  </div>
                  <div
                    style={{ width: "10%" }}
                    className={
                      ele?.status === "MAKER" || ele?.status === "CHECKER"
                        ? "pending"
                        : "accepted"
                    }
                  >
                    {ele?.status === "PAYMENT" ? "DELIVERED" : ele?.status}
                  </div>
                  <div style={{ width: "10%" }}>
                    {role === "CHECKER" && ele?.status === "MAKER" ? (
                      <>-</>
                    ) : (
                      <div
                        onClick={() =>
                          setSettlement({
                            status: true,
                            id: ele?.settlementId,
                            data: ele,
                          })
                        }
                        className={`activeButton ${Styles.settlementButton}`}
                      >
                        {role === "MAKER"
                          ? `${
                              ele?.status === "PAYMENT" ||
                              ele?.status === "CHECKER"
                                ? "View"
                                : "Settle"
                            } Transaction`
                          : role === "CHECKER"
                          ? `${
                              ele?.status === "PAYMENT" ? "View" : "Settle"
                            } Transaction`
                          : "View"}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SchdeuleTable;
